import { useCallback, useState } from "react";
import FourDPQuizContainer from "@/components/Quiz/4dpQuiz/FourDPQuizContainer";
import {
  FourDPQuizResultsType,
  TrainingProgressionUpdateType,
} from "@WahooFitness/cloud-client-types";
import FourDPQuizResults from "@/components/Quiz/4dpQuiz/Results/FourDPQuizResults";
import FourDpPages from "@/components/Quiz/4dpQuiz/FourDPPages";
import PowerZoneUpdate from "@/components/Quiz/4dpQuiz/PowerZoneUpdate/PowerZoneUpdate";
import FourDPEducation from "@/components/AthleteProfileEducation/fourDP/FourDPEducation";
import { useSearchParams } from "react-router-dom";
import { postClose, useHeaderContext } from "@WahooFitness/wahoo-offline-mfe";

function FourDPIndexPage() {
  const [searchParams] = useSearchParams();
  const closeOnBack = !!searchParams.get("from");
  const skipEducation = searchParams.has("skipEducation");
  const [page, setPage] = useState<FourDpPages>(
    skipEducation ? FourDpPages.quiz : FourDpPages.education
  );
  const [results, setResults] = useState<FourDPQuizResultsType>();
  const [initialTrainingProgression, setInitialTrainingProgression] =
    useState<TrainingProgressionUpdateType>();
  const [finishedEducation, setFinishedEducation] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const { navigateBack } = useHeaderContext();

  const handleQuizFirstStepBack = useCallback(() => {
    if (closeOnBack) {
      postClose("fourdp");
    } else {
      navigateBack();
    }
  }, [closeOnBack, navigateBack]);

  switch (page) {
    case FourDpPages.quiz:
      return (
        <FourDPQuizContainer
          setResults={setResults}
          setError={setError}
          setPage={setPage}
          skipEducation={true}
          setInitialTrainingProgression={setInitialTrainingProgression}
          onFirstStepBack={handleQuizFirstStepBack}
        />
      );
    case FourDpPages.results:
      return (
        <FourDPQuizResults
          results={results}
          setPage={setPage}
          error={error}
          closeOnBack={closeOnBack}
          initialTrainingProgression={initialTrainingProgression}
        />
      );
    case FourDpPages.zones:
      return <PowerZoneUpdate results={results} closeOnBack={closeOnBack} />;
    case FourDpPages.education:
    default:
      return (
        <FourDPEducation
          isStandAlone={false}
          setPage={setPage}
          finishedEducation={finishedEducation}
          setFinishedEducation={setFinishedEducation}
          closeOnBack={closeOnBack}
        />
      );
  }
}

export default FourDPIndexPage;
